import styled from 'styled-components'

const PopupStyle = styled.div.attrs()`
  background-color: rgba(1, 1, 1, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  z-index: 1000;
  opacity: 1;
  pointer-events: all;
`

export default PopupStyle
